import { render, staticRenderFns } from "./CustomSidebar.vue?vue&type=template&id=60cd3a8c"
import script from "./CustomSidebar.vue?vue&type=script&lang=js"
export * from "./CustomSidebar.vue?vue&type=script&lang=js"
import style0 from "./CustomSidebar.vue?vue&type=style&index=0&id=60cd3a8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports